/**
 * Turn a raw enum value into something a person should read.
 *
 * Status and type columns come back as snake_case straight from the database —
 * `sole_proprietor`, `pending_review`, `no_a2p`, `sole_prop_cap` — and any badge
 * that falls through to rendering the variable prints that verbatim. Agents were
 * seeing "sole_prop_cap" in the UI.
 *
 * Known values get a real label; anything unrecognised is de-underscored and
 * title-cased so a new enum value degrades to "Pending Review" rather than
 * leaking `pending_review`.
 */
const LABELS: Record<string, string> = {
  // A2P verification
  not_started: 'Not Started',
  pending_review: 'Pending Review',
  pending: 'Pending',
  verified: 'Verified',
  rejected: 'Rejected',
  expired: 'Expired',

  // brand types
  sole_proprietor: 'Sole Proprietor',
  low_volume_standard: 'Low Volume Standard',
  standard: 'Standard',

  // who a registration covers
  agency: 'Agency-wide',
  independent: 'Individual',

  // campaign link state
  linked: 'Linked',
  failed: 'Link Failed',
  no_a2p: 'Not Registered',
  sole_prop_cap: 'Not Registered', // a sole prop registers ONE number; the rest sit here
  agent_cap: 'Number Limit Reached',

  // carrier/brand review
  approved: 'Approved',
  in_progress: 'In Review',
};

export function humanizeStatus(value?: string | null): string {
  if (!value) return '';
  const key = String(value).toLowerCase().trim();
  if (LABELS[key]) return LABELS[key];
  return key
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
